import { PrintQRCode } from './PrintQRCode';
export default PrintQRCode;